import makeRequest from '@jg/http-client';
import { Auth } from '@jg/auth';
import uuid from 'uuid';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import fetchTeamData from './fetchTeamData';
import fetchEventDetails from './fetchEventDetails';
import {
  createTeamRequestMade,
  createTeamRequestSuccess,
  createTeamRequestError,
} from '../actionCreators/apiActions';

const createTeam = (name: string) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(createTeamRequestMade());
    const state = getState();
    const fundraiserPageGuid = state.app.frpId;
    const teamGuid = uuid();
    const body = JSON.stringify({ teamGuid, fundraiserPageGuid, name });
    const response = await makeRequest(`${config.pagesAPI}v1/teams`, {
      method: 'POST',
      body,
      extraHeaders: generateAuthHeaders(auth),
    });
    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.CREATE_TEAM);
    }
    dispatch(createTeamRequestSuccess());
    await dispatch(fetchTeamData(teamGuid));
    await dispatch(fetchEventDetails());
  } catch (error) {
    dispatch(createTeamRequestError(error.message));
    throw error;
  }
};

export default createTeam;
